import React, { Component } from "react";
import { Row, Col, Input, Select } from "antd";
import moment from "moment";
import tick from "../../../../../assets/icons/small-circle-tick.svg";
import history from "../../../../../history/history";
import {
  getPrimaryAccount,
  getAccountData
} from "../../../../../utils/sessionUtil";
import {
  HLine,
  GhostButtonDiv,
  FormHeading,
  SubmitHeading,
  BorderBottom,
  FormSubmitButton,
  SelectBox,
  LinkNavigatorPW
} from "./styles";
import {
  DataHeading,
  ErrorMsg,
  PrimaryButtonComponent,
  SectionLastHeading,
  CustomCheckbox,
  InputField
} from "../../../../../CommonComponents/commonStyles";
import { getpwUrl, moveIntoErrorPosition, recordError } from "../../../../../utils/commonUtil";
import asyncInterface from "../../../../../asyncInterface";
import { GeneralButton } from "../../../../../CommonComponents/Commons/commonComponents";

const { Option } = Select;

function submitTiffData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.recommendAnExchange.submitExchange(fetchPayload);
}

export default class TiffNotEligibleForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      isName: false,
      amount: "",
      isAmount: false,
      contact: null,
      isContact: false,
      email: null,
      emailValidation: null,
      phone: null,
      agreed: false,
      isAgreed: false,
      formDataSubmitted: false,
      enableButton: true,
      isFullNameDirty: false,
      isAmountDirty: false,
      isCheckBoxDirty: false
    };
  }
  
  UNSAFE_componentWillMount() {
    this.setState({
      formDataSubmitted: false
    });
    this.props.formDrupalContent([{
      payload: {
        method: "GET",
        page: "tiffEligibilityForm",
        url: `/conditional-contents?condition=tiff-beforesubmit`,
        isExternal: true
      }
    }
  ]);
    window.scrollTo(0, 0);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps) {
      this.setState({
        formDataSubmitted: nextProps.formDataSubmitted
      });
    }
  }
  handleInputChange = (e, type) => {
    switch (type) {
      case "name":
        let regName = /^[ a-zA-Z!@#\$%\^\&*\)\(+=._-]{0,150}$/;
        if (regName.test(e.target.value)) {
          this.setState({
            name: e.target.value
          },
            () => {
              this.checkEnabled();
            });
        }
        break;
      case "amount":
        let regAmount = /^[0-9]*(\.[0-9]{0,2})?$/;
        if (regAmount.test(e.target.value)) {
          this.setState({
            amount: e.target.value
          },
            () => {
              this.checkEnabled();
            }
          );
        }
        break;
      case "contact":
        this.setState(
          {
            contact: e,
            email: null,
            phone: null
          },
          () => {
            this.checkEnabled();
          }
        );
        break;
      case "email":
        this.setState({
          email: e.target.value
        },
          () => {
            this.checkEnabled();
          }
        );
        break;
      case "phone":
        let regPhone = /^[0-9()+-]{0,25}$/;
        if (regPhone.test(e.target.value)) {
          this.setState({
            phone: e.target.value
          },
            () => {
              this.checkEnabled();
            }
          );
        }
        break;
      case "agreed":
        this.setState(
          {
            agreed: !this.state.agreed,
            isCheckBoxDirty: e.target.checked
          },
          () => {
            this.checkEnabled();
          }
        );
        break;
      default:
        break;
    }
  };

  checkEmailValidation = () => {
    const { email, contact } = this.state;
    const regEmail = /^$|^\S+@\S+\.[a-zA-Z]{2,3}$/;
    if(contact === "email"){
        if (!email) {
          return false
        } else if (email && !regEmail.test(this.state.email)) {
          return false
        } else {
          return true
        }
    } else {
      return true
    }
   
  }

  checkPhoneValidation = () => {
    const {contact, phone} = this.state;
     if(contact  === "phone") {
        if(phone && phone !=="") {
          return true
        } else {
          return false
        }
     } else {
       return true
     }
  }


  handleBlur = () => {
    const { email } = this.state;
    const regEmail = /^$|^\S+@\S+\.[a-zA-Z]{2,3}$/;
    let emailValidation;
    if (!email) {
      emailValidation = "Please enter email";
    } else if (email && !regEmail.test(this.state.email)) {
      emailValidation = "Invalid email format";
    }
    this.setState({ emailValidation },
      () => {
        this.checkEnabled();
      });
  };

  handlePhoneBlur = () => {
    const {phone} = this.state
    if(phone === null || phone === "") {
      this.setState({ phone : "" },
        () => {
          this.checkEnabled();
        });
    }
  }

  handleAmountBlur = (e) => {
    if(e.target.value) {
      this.setState({isAmountDirty: false})
    } else {
      this.setState({isAmountDirty: true})
    }
  }

  handleNameBlur = (e) => {
    if(e.target.value) {
      this.setState({isFullNameDirty: false})
    } else {
      this.setState({isFullNameDirty: true})
    }
  }

  checkEnabled = () => {
    const {
      name,
      amount,
      contact,
      agreed,
      emailValidation,
      phone,
      email
    } = this.state;
    if (name === "") {
      this.setState({ isName: false }, () => this.checkIsValue())
    } else {
      this.setState({ isName: true }, () => this.checkIsValue())
    }

    if (amount === "") {
      this.setState({ isAmount: false }, () => this.checkIsValue())
    } else {
      this.setState({ isAmount: true }, () => this.checkIsValue())
    }

    if (contact === "default" || contact === "") {
      this.setState({ isContact: false }, () => this.checkIsValue())
    } else {
      this.setState({ isContact: true }, () => this.checkIsValue())
    }

    if (agreed === false) {
      this.setState({ isAgreed: false }, () => this.checkIsValue())
    } else {
      this.setState({ isAgreed: true }, () => this.checkIsValue())
    }
    if (
      (name !== "" && name !== null) &&
      (amount !== "" && amount !== null) &&
      (contact !== "default" && contact !== null) &&
      this.checkValidity(contact, emailValidation, phone, email) &&
      agreed !== false
    ) {
      this.setState({ enableButton: false });
    } else this.setState({ enableButton: true });
  };

  checkValidity = (contact, emailValidation, phone, email) => {
    if(contact === 'email') {
      return (!emailValidation && (email !="" && email!==null))
    } else if(contact === 'phone') {
      return (phone !== "" && phone !== null)
    } else {
      return false
    }
  }

  checkIsValue = () => {
    const {
      isName,
      isAmount,
      isContact,
      isAgreed
    } = this.state;
    if (isName ||
      isAmount ||
      isContact ||
      isAgreed) {
      this.props.valueInFormChange(true);
    }
    else this.props.valueInFormChange(false);
  }

  movePointer = (label, index) => {
    this.setState({[label]: true})
    setTimeout(() => {
      moveIntoErrorPosition(".error-fields", index);
    });
  }

  formValidation = () => {
    const {name, amount, contact, agreed} = this.state
    if(name !== "" && amount !== "" && (contact && contact !== 'default') && (this.checkEmailValidation()) && (this.checkPhoneValidation()) && agreed) {
      return true
    } else {
      if(name === "") {
        this.movePointer('isFullNameDirty', 0)
        return false
      }
      if(amount === "") {
        this.movePointer('isAmountDirty', 1)
        return false
      }
      if(!contact || contact === "default") {
        this.setState({contact: "default"})
        setTimeout(() => {
          moveIntoErrorPosition(".error-fields", 2);
        });
      }
      if(!contact || contact === "default") {
        this.setState({contact: "default"})
        setTimeout(() => {
          moveIntoErrorPosition(".error-fields", 2);
        });
      }
      if(!this.checkEmailValidation()) {
        this.handleBlur()
        setTimeout(() => {
          moveIntoErrorPosition(".error-fields", 3);
        });
      }
      if(!this.checkPhoneValidation()) {
        this.setState({phone: ""})
        setTimeout(() => {
          moveIntoErrorPosition(".error-fields", 3);
        });
      }
      if(!agreed) {
        this.movePointer('isCheckBoxDirty', 4)
        return false
      }
    }
  }

  submit = () => {
    try {
      if(this.formValidation()) {
        const { name, amount, contact, email, phone, agreed } = this.state;
        // Time converting to EST
        let newDate = new Date();
        let timeOfCall = moment(newDate).format("YYYY-MM-DD");
        //###################### API data
        let apiSubmitData = {
          contactChannel: "DP",
          timeOfCall: timeOfCall,
          description: "Requesting TIFF eligibility",
          noResponse: "Y",
          caseParty: {
            id: getAccountData().partyId
          },
          accountId: getPrimaryAccount().userId,
          category: {
            name: "Pool Exchange"
          },
          subCategory: {
            name: "Other"
          },
          comments: [
            {
              comments: `<b>Name</b>:${name}<br /><b>Amount</b>:${amount}<br /><b>Contact</b>:${contact}<br /><b>Email</b>:${email}<br /><b>Phone</b>:${phone}<br />`
            }
          ],
          queue: {
            name: "Contributions"
          }
        };
        const data = {
          method: "PUT",
          page: "TiffInviteForm",
          url: `/donor-portal/api/case/${getPrimaryAccount().userId}/save`,
          data: apiSubmitData
        };
        submitTiffData(data).then((response) => {
          this.props.submitDataSuccess(response.data)
        }).catch(err => {
          this.props.submitDataError(err)
        })
      }
    } catch (error) {
      recordError(error);
    }
  };

  render() {
    const {
      name,
      amount,
      contact,
      email,
      phone,
      agreed,
      formDataSubmitted,
      emailValidation,
      isFullNameDirty,
      isAmountDirty,
      isCheckBoxDirty
    } = this.state;
    const { beforeSubmitData, afterSubmitData } = this.props;
    
      if (formDataSubmitted === false) {
        return (
          <>
             {
                beforeSubmitData.isLoading ? 
                (
                  <>
                    <SectionLastHeading>TIFF exchange eligibility notice</SectionLastHeading>
                    <DataHeading dangerouslySetInnerHTML={{ __html: "<p>Please review the following eligibility requirements for TIFF.</p><ol><li>The minimum initial investment is $50,000, additional exchanges must be $10,000 or more, and each exchange results in an entry or exit fee.</li><li>Only accounts with ongoing balances of $100,000 or more are eligible to invest in the Multi-Asset Pool.</li><li>A maximum of 90% of your account's total balance may be invested in the Multi-Asset Pool.</li></ol> "}} >
                    </DataHeading>
                  </>
                ) : 
              (
                <>
                    <SectionLastHeading>{beforeSubmitData.data[0].field_header}</SectionLastHeading>
                    <DataHeading dangerouslySetInnerHTML={{ __html: beforeSubmitData.data[0].description__value }} ></DataHeading>
                </>
              )
            }
            <FormHeading>TIFF exchange request form</FormHeading>

            <Row>
              <Col lg={{ span: 8 }} md={{ span: 8 }}>
                <DataHeading className="mb-10">Full Name</DataHeading>
                <InputField
                  aria-label="nameForm"
                  id="txtFirstName"
                  placeholder="Enter name"
                  className="not-rounded h-40"
                  onBlur={e => this.handleNameBlur(e)}
                  onChange={e => this.handleInputChange(e, "name")}
                  value={name}
                  max={150}
                  data-test="nameInput-change"
                />
                <ErrorMsg visible={!(name === "" && isFullNameDirty) && "hidden"}>Please enter name</ErrorMsg>
              </Col>
              <Col lg={{ span: 8, offset: 1 }} md={{ span: 8, offset: 1 }} className="mt-xs-20">
                <DataHeading className="mb-10">Amount for TIFF</DataHeading>
                <InputField
                  aria-label="amountForm"
                  id="txtAmountForTiff"
                  placeholder="Enter the amount"
                  className="not-rounded h-40"
                  onBlur={e => this.handleAmountBlur(e)}
                  onChange={e => this.handleInputChange(e, "amount")}
                  value={amount}
                  max={150}
                  data-test="amountInput-change"
                />
                <ErrorMsg visible={!(amount === "" && isAmountDirty) && "hidden"}>Please enter amount</ErrorMsg>
              </Col>
            </Row>
            <Row className="mt-20">
              <Col lg={{ span: 8 }} md={{ span: 8 }}>
                <DataHeading className="mb-10">Contact Method</DataHeading>
                <SelectBox
                  role={false}
                  id="selContactMethod"
                  defaultValue="default"
                  onChange={e => this.handleInputChange(e, "contact")}
                  className="w100 not-rounded"
                  showArrow={true}
                  data-test="contactInput-change"
                >
                  <Option value="default">- Select -</Option>
                  <Option value="email">Email</Option>
                  <Option value="phone">Phone</Option>
                </SelectBox>
                <ErrorMsg visible={contact !== "default" && "hidden"}>Please enter contact</ErrorMsg>
              </Col>
              <Col lg={{ span: 8, offset: 1 }} md={{ span: 8, offset: 1 }} className="mt-xs-20">
                {contact === "email" && (
                  <>
                    <DataHeading className="mb-10">Contact Email</DataHeading>
                    <InputField
                      aria-label="emailForm"
                      id="txtContactEmail"
                      placeholder="Enter email"
                      type="email"
                      onBlur={this.handleBlur}
                      onChange={e => this.handleInputChange(e, "email")}
                      value={email}
                      className="not-rounded h-40"
                      data-test="emailInput-change"
                    />
                    <ErrorMsg visible={!emailValidation && "hidden"}>{emailValidation}</ErrorMsg>
                  </>
                )}
                {contact === "phone" && (
                  <>
                    <DataHeading className="mb-10">Contact Phone</DataHeading>
                    <InputField
                      aria-label="contactForm"
                      id="txtContactPhone"
                      onBlur={this.handlePhoneBlur}
                      placeholder="Enter phone"
                      className="not-rounded h-40"
                      onChange={e => this.handleInputChange(e, "phone")}
                      value={phone}
                      max={150}
                      data-test="phoneInput-change"
                    />
                    <ErrorMsg visible={phone !== "" && "hidden"}>Please enter phone</ErrorMsg>
                  </>
                )}
              </Col>
            </Row>

            <CustomCheckbox
              id="chkTIFFTerms"
              value={agreed}
              onChange={e => this.handleInputChange(e, "agreed")}
              className="mt-40"
              data-test="agreedInput-change"
            >
              By checking this box and clicking Submit you agree that you have
              read the TIFF <LinkNavigatorPW href={`${getpwUrl()}company-policies/policies-and-guidelines`} target="_blank">terms and conditions</LinkNavigatorPW>.
          </CustomCheckbox>
          <ErrorMsg visible={!(isCheckBoxDirty && !agreed) && "hidden"}>Please check the box to proceed</ErrorMsg>

            <BorderBottom />
            <FormSubmitButton>
              <GeneralButton 
                  width="150px" 
                  data-test="tiffForm-btn" 
                  text="Submit" 
                  id="btnSubmit"  
                  onClick={this.submit}
              />
            </FormSubmitButton>
          </>
        );
      }
      else {
        return (
          <>
          {
            afterSubmitData.isLoading ? <SectionLastHeading>TIFF exchange request</SectionLastHeading> :
            <SectionLastHeading>{afterSubmitData.data[0].field_header}</SectionLastHeading>
          }
            <SubmitHeading>
              <img src={tick} alt="tick" className="mr-20" />
              Your request has been submitted
          </SubmitHeading>
          {
           afterSubmitData.isLoading ? 
            <DataHeading dangerouslySetInnerHTML={{ __html: "\u003Cp\u003EThank you for submitting a Tiff exchange eligibility form. We will review the form and reach out to you within 2 business days.\u003C\/p\u003E"}} >
            </DataHeading> :
            <DataHeading dangerouslySetInnerHTML={{ __html: afterSubmitData.data[0].description__value}} >
            </DataHeading>
          }
            <HLine />
            <GeneralButton 
                type="functional" 
                inverted={true} 
                width="150px" 
                text="BACK TO HOME" 
                id="btnBackToHome" 
                onClick={() => history.push("/")}
            />
          </>
        );
      }
  }
}
